import { Auth } from '@freelancer/auth';
import { arrayIsShallowEqual, Datastore, } from '@freelancer/datastore';
import * as Rx from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { featureFlagConfigurations, SiteTheme, } from './feature-flags.model';
import * as i0 from "@angular/core";
import * as i1 from "../datastore/core/datastore";
import * as i2 from "../auth/auth.service";
import * as i3 from "../ui/ui.config";
var FeatureFlagsService = /** @class */ (function () {
    function FeatureFlagsService(datastore, auth, uiConfig) {
        this.datastore = datastore;
        this.auth = auth;
        this.uiConfig = uiConfig;
        var theme = this.uiConfig.theme;
        if (theme !== undefined && theme in featureFlagConfigurations) {
            this.flagConfig$ = Rx.of(featureFlagConfigurations[theme]);
            return;
        }
        var currentUserDoc = this.datastore.document('users', this.auth.getUserId());
        // combine the status and value observables into an `Rx.Observable<User | undefined>`
        var loadedUser$ = currentUserDoc.status$.pipe(switchMap(function (status) {
            return status.error ? Rx.of(undefined) : currentUserDoc.valueChanges();
        }), distinctUntilChanged(function (a, b) {
            return !!a && !!b && arrayIsShallowEqual(a.enterpriseIds, b.enterpriseIds);
        }));
        this.flagConfig$ = this.auth.isLoggedIn().pipe(switchMap(function (loggedIn) {
            return loggedIn
                ? loadedUser$.pipe(map(function (user) {
                    // Datastore errored, fallback to default theme
                    if (!user) {
                        return featureFlagConfigurations[SiteTheme.DEFAULT];
                    }
                    if (user.isDeloitteDcUser) {
                        return featureFlagConfigurations[SiteTheme.DELOITTE];
                    }
                    return featureFlagConfigurations[SiteTheme.DEFAULT];
                }))
                : Rx.of(featureFlagConfigurations[SiteTheme.DEFAULT]);
        }));
    }
    FeatureFlagsService.prototype.getFlag = function (feature) {
        return this.flagConfig$.pipe(map(function (config) { return config[feature]; }));
    };
    FeatureFlagsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureFlagsService_Factory() { return new FeatureFlagsService(i0.ɵɵinject(i1.Datastore), i0.ɵɵinject(i2.Auth), i0.ɵɵinject(i3.UI_CONFIG)); }, token: FeatureFlagsService, providedIn: "root" });
    return FeatureFlagsService;
}());
export { FeatureFlagsService };
